/* eslint-disable no-unused-vars */
/* eslint-disable arrow-body-style */
import React from 'react';
import { useSelector } from 'react-redux';
import {
    Area,
    AreaChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    // eslint-disable-next-line prettier/prettier
    YAxis
} from 'recharts';

const SalesChart = ({ selected }) => {
    const data = useSelector((state) => state.reports.data);
    const { reportData } = useSelector((state) => state.reports);
    return (
        <ResponsiveContainer width="99%" aspect={3.0 / 1.0}>
            <AreaChart
                // width={720}
                // height={300}
                data={reportData}
                margin={{ top: 10, right: 10, left: 0, bottom: 10 }}
            >
                <defs>
                    <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="rgba(2,204,135)" stopOpacity={0.08} />
                        <stop offset="95%" stopColor="rgba(2,204,135)" stopOpacity={0} />
                    </linearGradient>
                    <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="5%" stopColor="rgba(0,150,255)" stopOpacity={0.05} />
                        <stop offset="95%" stopColor="rgba(0,150,255)" stopOpacity={0} />
                    </linearGradient>
                </defs>
                <XAxis
                    dataKey="post_date"
                    tick={{
                        fontSize: 13,
                        fill: 'rgb(120, 129, 143)',
                    }}
                    axisLine={false}
                    tickLine={false}
                    tickMargin="20"
                />
                <YAxis
                    tick={{
                        fontSize: 13,
                        fill: 'rgb(120, 129, 143)',
                    }}
                    axisLine={false}
                    tickLine={false}
                    tickMargin="15"
                />
                <CartesianGrid
                    strokeDasharray="3 3"
                    // vertical={false}
                    stroke="#EBEFF8"
                />
                <Tooltip
                    cursor={{
                        strokeWidth: 1,
                        stroke: 'rgb(175, 175, 176, 0.15)',
                    }}
                    wrapperStyle={{ background: 'bg-dark' }}
                    labelStyle={{
                        color: 'text-secondary',
                        fontSize: '13px',
                    }}
                />

                <Area
                    type="monotone"
                    dataKey="total_sales"
                    stroke="rgb(24, 136, 245)"
                    strokeWidth="2.5"
                    fillOpacity={1}
                    fill="url(#colorPv)"
                    activeDot={{
                        stroke: '#fff',
                        strokeWidth: 4,
                        r: 8,
                    }}
                />
                <Area
                    type="monotone"
                    dataKey="total_orders"
                    stroke="rgb(255, 75, 10)"
                    strokeWidth="2.5"
                    fillOpacity={1}
                    fill="url(#colorPv)"
                    activeDot={{
                        stroke: '#fff',
                        strokeWidth: 4,
                        r: 8,
                    }}
                />
            </AreaChart>
        </ResponsiveContainer>
    );
};

export default SalesChart;
